import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

const ConsentDialog = ({ open, onConsent }) => {
    return (
        <Dialog open={open} onClose={() => onConsent(false)}>
            <DialogTitle>User Consent</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    Welcome to our survey! Please take a moment to review the following consent notice before proceeding:
                </Typography>
                <Typography variant="body2" style={{ marginTop: 16 }}>
                    <strong>1. Purpose of the Survey:</strong> The survey is designed to gather feedback and insights that will be used to improve [service/product/experience].
                </Typography>
                <Typography variant="body2" style={{ marginTop: 8 }}>
                    <strong>2. Anonymity:</strong> We do not collect any personal identifying information. Your responses will remain completely anonymous, and individual responses cannot be traced back to you.
                </Typography>
                <Typography variant="body2" style={{ marginTop: 8 }}>
                    <strong>3. Data Usage:</strong> The data collected from this survey will be used solely for the purposes outlined above. Aggregated results may be published or shared to improve our services, but no individual data will be disclosed.
                </Typography>
                <Typography variant="body2" style={{ marginTop: 8 }}>
                    <strong>4. Confidentiality:</strong> The survey platform and our team ensure the highest level of confidentiality for your responses.
                </Typography>
                <Typography variant="body1" style={{ marginTop: 16 }}>
                    By proceeding, you agree to participate in this survey under these terms. Thank you for your valuable input!
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onConsent(true)} variant="contained" color="primary">
                    I Agree
                </Button>
                <Button onClick={() => onConsent(false)} variant="outlined" color="secondary">
                    Decline
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConsentDialog;
